export enum AnimationStatus {
	Active = 'Active',
	Initial = 'Initial',
	Entering = 'Entering',
	Exiting = 'Exiting',
}
